export default {
  "AutoPilotSection": "_AutoPilotSection_183ys_1",
  "Paragraph": "_Paragraph_183ys_2"
};import "ni:sha-256;W4crI3VTu6-fXeKpdLPRCHwxyB37-LzXvTp4PGHwoqU";